module.exports = __webpack_public_path__ + "static/media/closed-eye.f5dc7a6a.svg";